export const processDataFromArrayOfObject = (countryList, code) => {
  const codes = countryList.map(function (country) {
    return country[code];
  });
  return codes;
};

export const processStoresData = (stores) => {
  let storeNames = stores.map((store) => store.storeName);
  return storeNames;
};

export const filteredStore = (stores, selectedStore) => {
  const store = stores.filter((data) => {
    return data.storeName === selectedStore;
  });
  return store;
};
